<h2 mat-dialog-title>Selecciona un perfil</h2>
<mat-dialog-content>
  <p>Tienes múltiples roles disponibles. <br>¿Cómo deseas ingresar?</p>

  <mat-form-field appearance="outline" class="w-200">
    <mat-label>Rol / Tipo de Acceso</mat-label>
    <mat-select [formControl]="contextoControl">

      <mat-option>
        <ngx-mat-select-search
          [formControl]="filterControl"
          placeholderLabel="Buscar..."
          noEntriesFoundLabel="No se encontraron resultados">
        </ngx-mat-select-search>
      </mat-option>

      @if (globalesFiltrados.length > 0) {
        <mat-optgroup label="Global">
          @for (ctx of globalesFiltrados; track ctx.rol) {
            <mat-option [value]="ctx">
              {{ etiqueta(ctx) }}
            </mat-option>
          }
        </mat-optgroup>
      }

      @for (liga of ligasFiltradas; track liga.nombre) {
        <mat-optgroup [label]="liga.nombre">
          @for (ctx of liga.contextos; track ctx.rol) {
            <mat-option [value]="ctx">
              {{ ctx.rol }}
            </mat-option>
          }
        </mat-optgroup>
      }

      @for (equipo of equiposFiltrados; track equipo.nombre) {
        <mat-optgroup [label]="equipo.nombre">
          @for (ctx of equipo.contextos; track ctx.rol) {
            <mat-option [value]="ctx">
              {{ ctx.rol }}
            </mat-option>
          }
        </mat-optgroup>
      }

      @for (escuela of escuelasFiltradas; track escuela.nombre) {
        <mat-optgroup [label]="escuela.nombre">
          @for (ctx of escuela.contextos; track ctx.rol) {
            <mat-option [value]="ctx">
              {{ ctx.rol }}
            </mat-option>
          }
        </mat-optgroup>
      }

    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-icon-button
          (click)="actualizarContextos()"
          [disabled]="cargando()"
          matTooltip="Actualizar roles disponibles">
    @if (cargando()) {
      <mat-spinner diameter="18" />
    } @else {
      <mat-icon>refresh</mat-icon>
    }
  </button>

  <button mat-flat-button color="primary"
          (click)="confirmarSeleccion()"
          [disabled]="contextoControl.invalid || cargando()">
    Continuar
  </button>
</mat-dialog-actions>
